const defaultSystemFonts = [
  'San Francisco',
  'Arial',
  'ArialHebrew',
  'Avenir',
  'Baskerville',
  'Bodoni 72',
  'Bradley Hand',
  'Chalkboard SE',
  'Cochin',
  'Copperplate',
  'Courier',
  'Courier New',
  'Damascus',
  'Didot',
  'Futura',
  'Geeza Pro',
  'Georgia',
  'Gill Sans',
  'Helvetica',
  'Helvetica Neue',
  'Hiragino Sans',
  'Hoefler Text',
  'Iowan Old Style',
  'Kailasa',
  'Khmer Sangam MN',
  'Marker Felt',
  'Menlo',
  'Mishafi',
  'Noteworthy',
  'Optima',
  'Palatino',
  'Papyrus',
  'Savoye LET',
  'Symbol',
  'Thonburi',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Zapf Dingbats',
  'Zapfino'
];

export default defaultSystemFonts;
